import { setGetListHistoryAction } from '../action';
import { getListHistory } from '../api/getListHistory';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetListHistory = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getListHistory(params);

            if (data.status === 'success') {
                const history = [...getState().adminMobile.history.data];
                history.push(data.data);
                dispatch(setGetListHistoryAction({
                    data: history.flat(1),
                    countPage: data.countPage
                }));
                dispatch(setLoadingAction(false))
            }

        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetListHistory
}